import simpleRestDataProvider, { axiosInstance } from "@refinedev/simple-rest";
import type { DataProvider } from "@refinedev/core";
import { ADMIN_API_URL, TOKEN_KEY } from "@/lib/constants";
import { MOCK_ENABLED } from "@/mock/flag";
import { mockDataProvider } from "@/mock/mockDataProvider";

/**
 * dataProvider do melapp-admin = @refinedev/simple-rest apontando para
 * `${VITE_API_URL}/admin`. Cada `resource` do Refine vira `/admin/<resource>`
 * (ex.: resource "users" → GET /admin/users; lê X-Total-Count p/ paginação).
 *
 * IMPORTANTE: @refinedev/simple-rest usa AXIOS como httpClient (chama
 * httpClient[method](url) → {data, headers}). Passar o `fetch` cru quebra com
 * "t[m] is not a function". Por isso injetamos o Bearer admin via interceptor
 * no `axiosInstance` exportado pelo simple-rest (e mantemos o cookie httpOnly).
 */
axiosInstance.interceptors.request.use((config) => {
  const token = localStorage.getItem(TOKEN_KEY);
  if (token) config.headers.Authorization = `Bearer ${token}`;
  config.withCredentials = true; // mantém o cookie de refresh httpOnly
  return config;
});

const base = simpleRestDataProvider(ADMIN_API_URL, axiosInstance);

const realDataProvider: DataProvider = {
  ...base,
  getApiUrl: () => ADMIN_API_URL,
};

/**
 * Em MOCK MODE (VITE_MOCK) usa o mockDataProvider (fixtures offline). Com a API
 * real (VITE_MOCK=false) usa o simple-rest acima.
 */
export const dataProvider: DataProvider = MOCK_ENABLED
  ? mockDataProvider
  : realDataProvider;
